import { Link } from "react-router-dom";
import { ArrowRight, Gift, Snowflake } from "lucide-react";
import { isDecemberUK } from "../../lib/season";
import { useSiteSettings } from "../../lib/siteSettings";

export function ChristmasBanner() {
  const settings = useSiteSettings();
  if (!isDecemberUK() && settings?.theme !== "christmas") return null;
  return (
    <Link to="/presents" data-testid="home-christmas-banner"
      className="group relative flex items-center gap-3 overflow-hidden rounded-[22px] border-[3px] border-[#0B3D2E] bg-[#C8102E] px-4 py-3 text-white shadow-[0_5px_0_#0B3D2E] transition-transform hover:-translate-y-0.5 sm:gap-5 sm:px-6 sm:py-4">
      <Snowflake className="absolute -right-3 -top-3 h-20 w-20 text-white/15" strokeWidth={2} />
      <Snowflake className="absolute bottom-1 left-1/2 h-8 w-8 text-white/15" strokeWidth={2} />
      <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border-[3px] border-[#0B3D2E] bg-[#1F8A4C] -rotate-6 transition-transform group-hover:rotate-6 sm:h-16 sm:w-16">
        <Gift className="h-8 w-8 text-[#FFE14D]" strokeWidth={2.5} />
      </span>
      <span className="relative min-w-0 flex-1">
        <span className="block text-[10px] font-extrabold uppercase tracking-[0.25em] text-[#FFE14D] sm:text-xs">{isDecemberUK() ? "It's December!" : "Christmas is coming!"}</span>
        <span className="ua-title block text-2xl leading-none sm:text-4xl">Christmas gift finder</span>
        <span className="mt-0.5 block text-sm font-bold text-white/90 sm:text-base">Find the perfect present in seconds</span>
      </span>
      <span className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full border-[3px] border-[#0B3D2E] bg-[#FFE14D] text-[#0B3D2E] transition-transform group-hover:translate-x-1">
        <ArrowRight className="h-5 w-5" strokeWidth={3} />
      </span>
    </Link>
  );
}
